import { NotificationsNone } from "@mui/icons-material";
import {
  Badge,
  IconButton,
  Link,
  List,
  ListItemButton,
  ListItemText,
  Stack,
  Typography,
} from "@mui/material";
import Iconify from "components/Iconify";
import MenuPopover from "components/menu-popover";
import Scrollbar from "components/Scrollbar";

import dayjs from "dayjs";

import { useState } from "react";
import { useTranslation } from "react-i18next";
import { useNotification } from "recoil/notification";

import ReactGA from "react-ga4";

const MenuNotification = () => {
  const { t } = useTranslation(["translation"]);
  const [openPopover, setOpenPopover] = useState(null);
  const { notifications, totalUnRead, handleReadNotification } = useNotification();
  const handleOpenPopover = (event) => {
    setOpenPopover(event.currentTarget);
    ReactGA.event("notifacation", {
      user_interaction: "open",
    });
  };

  const handleClosePopover = () => {
    setOpenPopover(null);
  };

  return (
    <>
      <IconButton aria-label="notification" onClick={handleOpenPopover}>
        <Badge badgeContent={totalUnRead} color="warning">
          <NotificationsNone color="primary" />
        </Badge>
      </IconButton>
      <MenuPopover
        open={openPopover}
        onClose={handleClosePopover}
        arrow="top-center"
        sx={{ width: 320, p: 0 }}
      >
        <Scrollbar sx={{ p: 1, maxHeight: "calc(100vh - 100px)" }} autoHide={true}>
          <List disablePadding>
            {notifications.map((notification, index) => (
              <ListItemButton
                key={notification.id}
                sx={{
                  py: 1,
                  px: 2,
                  mt: index === 0 ? 0 : 0.5,
                  ...(notification.isUnRead && {
                    bgcolor: "#F2F9EF",
                  }),
                  borderRadius: "4px",
                  "&:hover": {
                    "#notification-list-item-title": {
                      textDecoration: "underline",
                    },
                  },
                }}
                onClick={() => handleReadNotification(notification.id)}
                href={notification.path}
                target="_blank"
              >
                <ListItemText
                  disableTypography
                  primary={
                    <>
                      <Typography
                        id="notification-list-item-title"
                        variant="subtitle2"
                        color="primary.main"
                      >
                        {notification.title}
                      </Typography>
                      <Typography
                        component="span"
                        variant="body3"
                        sx={{ color: "text.secondary", lineHeight: "-1rem" }}
                      >
                        {notification.description}
                      </Typography>
                    </>
                  }
                  secondary={
                    <Stack direction="row" justifyContent="space-between" sx={{ mt: 0.5 }}>
                      {notification.createdAt && (
                        <Stack
                          direction="row"
                          sx={{ typography: "caption", color: "text.disabled" }}
                        >
                          <Iconify icon="eva:clock-fill" sx={{ mr: 0.5, width: 16, height: 16 }} />
                          <Typography variant="caption">
                            {dayjs(notification.createdAt).format(t("formatDate.fullDateTime"))}
                          </Typography>
                        </Stack>
                      )}
                      {notification.path && <Link variant="caption">{t("read more")}</Link>}
                    </Stack>
                  }
                />
              </ListItemButton>
            ))}
            {notifications.length === 0 && (
              <Stack alignItems="center">
                <Typography variant="body3" sx={{ color: "text.secondary" }}>
                  {t("notfound")}
                </Typography>
              </Stack>
            )}
          </List>
        </Scrollbar>
      </MenuPopover>
    </>
  );
};

export default MenuNotification;
